<div class="cart-item" *ngIf="cartItem">
  <button
    class="remove-icon-button"
    (click)="removeHandler$.emit(cartItem.mainWallItemId)"
  >
    <svg
      class="remove-icon"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4C13.6266 4 11.3066 4.70379 9.33316 6.02236C7.35977 7.34094 5.8217 9.21508 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.6936 20.6689 5.83649 22.807 7.51472 24.4853C9.19295 26.1635 11.3311 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6934 28 18.3734 28 16C27.9957 12.8187 26.73 9.76898 24.4805 7.51947C22.231 5.26997 19.1813 4.0043 16 4V4ZM21.6949 17.0169H10.3051C10.0354 17.0169 9.77671 16.9098 9.586 16.7191C9.39528 16.5284 9.28814 16.2697 9.28814 16C9.28814 15.7303 9.39528 15.4716 9.586 15.2809C9.77671 15.0902 10.0354 14.983 10.3051 14.983H21.6949C21.9646 14.983 22.2233 15.0902 22.414 15.2809C22.6047 15.4716 22.7119 15.7303 22.7119 16C22.7119 16.2697 22.6047 16.5284 22.414 16.7191C22.2233 16.9098 21.9646 17.0169 21.6949 17.0169Z"
        fill="#FE3F03"
      />
    </svg>
  </button>
  <div class="cart-item-photo">
    <img
      alt="cart item"
      class="item-preview"
      width="250"
      height="250"
      [src]="cartItem.tiles[0].image"
    />
  </div>
  <div class="preview-info">
    <p class="preview-info--description">
      {{ cartItem.tiles.length | sqrt }}x{{ cartItem.tiles.length | sqrt }}
    </p>
  </div>
  <div class="cart-price">
    <svg width="27" height="24" viewBox="0 0 27 24">
      <use href="#ethereum-icon" />
    </svg>
    <div class="ethereum-currency">
      <span class="eth-price">{{ price }}</span>
      <span class="usd">
        {{ (price || 0) * ethereumPrice | currency: "USD":"symbol":"1.0-4" }}
      </span>
    </div>
  </div>
</div>
